import { axiosModules } from "@qubit-utill/src";

export default {
  getHostPath: () => axiosModules.get("/pstats/logindetect/hostpath"),
  getDayTopList: (params) => axiosModules.get("/pstats/logindetect/day/hour", params),
  getWeekTopList: (params) => axiosModules.get("/pstats/logindetect/week/hour", params),
  getMonthTopList: (params) => axiosModules.get("/pstats/logindetect/month/hour", params),
};
